import { render } from "./rangemessage.vue?vue&type=template&id=83c6840a&scoped=true"
import script from "./rangemessage.vue?vue&type=script&lang=js"
export * from "./rangemessage.vue?vue&type=script&lang=js"

import "./rangemessage.vue?vue&type=style&index=0&id=83c6840a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83c6840a"]])

export default __exports__